module.exports = __webpack_public_path__ + "media/stylesheets/images/userway_logo_images/united-way-f0c954b1571ec6bd7e17093c988e5feb.png";